import { TypedChangingEntityString } from '../../generated/api/kreditportalBackendAPI.schemas';

export class TypedChangingEntityFactory {

    static createByValue(value: string): TypedChangingEntityString {
        return {
            oldValue: value,
            recentValue: value,
            validationResult: true,
            changed: false
        }
    }

}
